export const buildingImages = [
    { image: "../images/building/gallery/1.jpg", caption: "Roof Terrace" },
    { image: "../images/building/gallery/2.jpg", caption: "Reception" },
    { image: "../images/building/gallery/3.jpg", caption: "First Floor Cat A" },  
];